import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (subcontractor) => async (dispatch) => {

  dispatch(push(getTeamUrl(`subcontractors/${subcontractor.id}/view`)))
  
}